// src/components/AuthErrorPage.js

import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Box, Typography, Button, Container, Paper } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import { getLoginUrl } from "../utils/auth";

/**
 * Error page displayed when authentication fails
 * Provides helpful information and login redirection
 */
const AuthErrorPage = ({ error }) => {
  const loginUrl = getLoginUrl();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          textAlign: "center",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: 2,
          }}
        >
          <ErrorIcon color="error" sx={{ fontSize: 60, mb: 2 }} />

          <Typography variant="h4" component="h1" gutterBottom>
            Authentication Error
          </Typography>

          <Typography variant="body1" color="text.secondary" paragraph>
            There was a problem authenticating your account. This could be due to an expired session
            or missing login credentials.
          </Typography>

          {error && (
            <Typography
              variant="body2"
              color="error"
              sx={{
                mb: 3,
                fontFamily: "monospace",
                p: 2,
                bgcolor: "#f5f5f5",
                borderRadius: 1,
                width: "100%",
              }}
            >
              {error}
            </Typography>
          )}

          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              window.location.href = loginUrl;
            }}
            sx={{ mt: 2 }}
          >
            Go to Login
          </Button>

          <Button component={Link} to="/" variant="text" sx={{ mt: 2 }}>
            Return to Home
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

// PropTypes validation
AuthErrorPage.propTypes = {
  error: PropTypes.string,
};

// Default props
AuthErrorPage.defaultProps = {
  error: null,
};

export default AuthErrorPage;
